import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { STATUS } from 'state/requestStatus/reducer';
import FullScreenModal from 'components/static/FullScreenModal';
import {Spacer} from 'layout/util'
import {CloseIcon} from 'components/static/icons'

import {
  TextField,
  SubmitButtonWithStyle,
} from 'components/interactive/forms/form-styles';

import styled from 'styled-components';

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseIconStyle = styled.div`
  height: 22px;
  width: 22px;
  cursor: pointer;
`;

class FlagModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: "",
      contactInfo: "",
    };
  }

  handleInputChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { store } = this.context;
    store.dispatch({
      type: "FLAG_REQUESTED",
      payload: {
        reason: this.state.reason,
        contactInfo: this.state.contactInfo,
        resource: this.props.resource,
      }
    });
  }

  //-- to toggle visibility, pass as prop to give access to children
  toggleVisibility = (forceVisible) => {
    if(forceVisible === false) {
      this.props.onCancel();
    }
  }

  render () {
    const { message, status } = this.props;
    const ExitButton = 
        <CloseIconStyle onClick={this.props.onCancel}>
          <CloseIcon />
        </CloseIconStyle>
      
    return (
      <FullScreenModal 
        overlayColor="rgba(0,0,0,0.5)"
        onToggleVisibility={this.toggleVisibility}
      >
        <form onSubmit={this.handleSubmit}>
          <Spacer height={10}/>
          <TitleWrapper>
            <h4>
              Report this page to us
            </h4>
            {ExitButton}
          </TitleWrapper>
          <Spacer height={10}/>
          <TextField
            id='flag-reason'
            required={true}
            type='text'
            name='reason'
            placeholder="Tell us what the issue is"
            value={this.state.reason}
            onChange={this.handleInputChange}
          />
          <TextField
            id='flag-contactInfo'
            required={false}
            type='text'
            name='contactInfo'
            placeholder="you@email.address (Optional) "
            value={this.state.contactInfo}
            onChange={this.handleInputChange}
          />
          { (!message && status !== STATUS.NONE) && <h3>Sending...</h3>}
          { message && <h3>{ message }</h3> }
          { status === STATUS.NONE &&
            <SubmitButtonWithStyle
              id='flag-submit'
              value='Send'
              disabled={status !== STATUS.NONE}
              name='submit'
            />
          }
        </form>
      </FullScreenModal>
    );
  }
}

FlagModal.contextTypes = {
  store: PropTypes.object
};

FlagModal.propTypes = {
  resource: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};

class FlagContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFlagModal: false
    };
  }

  toggleFlagModal = (event) => {
    this.setState({
      showFlagModal: !this.state.showFlagModal
    });
  }

  render () {
    const { text, resource, flag } = this.props;

    let modal = null;
    if (this.state.showFlagModal) {
      modal = <FlagModal
        resource={resource}
        message={flag.message}
        status={flag.status}
        onCancel={this.toggleFlagModal}
      />;
    }

    let link = null;
    if (!this.state.showFlagModal) {
      link = (
        <div onClick={this.toggleFlagModal}>
          { text }
        </div>
      );
    }

    return (
      <React.Fragment>
        { modal }
        { link }
      </React.Fragment>
    );
  }
}

FlagContent.propTypes = {
  text: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const { flag } = state;
  return { flag };
}

export default connect(mapStateToProps, {})(withRouter(FlagContent));




// WEBPACK FOOTER //
// ./src/components/interactive/flag-content.js